<template>
	<div>
      <v-container grid-list-xl>
        <center v-if="objUserNotifications.users == null"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" /></center>
        <v-flex xs3 v-if="objUserNotifications.users != null">
          <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
        </v-flex>
        <v-data-table v-if="objUserNotifications.users != null" loading="true" :headers="headers" :items="objUserNotifications.users" :search="search" hide-actions disable-initial-sort class="elevation-1 linkTableMedium">
          <template slot="items" slot-scope="props">
            <tr class="sortableRow" id="rows" v-if="props.item.active == 1 && props.item.description != 'User Confirmation Email' && props.item.description != 'Email Template' && !props.item.description.includes('RFC')">
              <td width="70%">{{ props.item.description }}</td>
              <td width="10%"><v-switch v-model="props.item.get_sms"></v-switch></td>
              <td width="10%"><v-switch v-model="props.item.get_email"></v-switch></td>
              <td width="10%"><v-switch v-model="props.item.get_push"></v-switch></td>
            </tr>
          </template>
        </v-data-table>
        <v-layout row wrap class="pl-4 pr-4 pt-4 pb-4">
          <div class="pl-4 pr-1 pb-2 buttonHolder">
            <div style="float: right">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
              <v-btn color="success" class="text-xs-right" @click.stop="fncEditNotifications()">Save</v-btn>
            </div>
          </div>
        </v-layout>
      </v-container>
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
        name: 'UserNotifications',
        components: {},
		data () {
          return {
            search: '',
            headers: [
              { text: 'Description', value: 'description', width: '70%' },
              { text: 'Sms', value: 'sms', width: '10%' },
              { text: 'Email', value: 'email', width: '10%' },
              { text: 'Push', value: 'push', width: '10%' }
            ]
			}
		},
		methods: {
            fncHideModal () {
                this.$store.commit('hideModal');
            },
            fncEditSettings() {
                this.$store.dispatch('fncEditSettings', this.objUserSettings);
            },
            fncEditNotifications() {
              this.$store.dispatch('fncEditNotifications', this.globalModalParams.userId);
            }
		},
		computed: {
			...mapGetters([
                'objAuthorize',
                'globalModalParams',
				'objUserNotifications'
			])
        }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>
